import { Box, List, Button, Typography } from "@material-ui/core";
import React from "react";
import { useHistory } from "react-router-dom";
import usePathStyles from "./Report/src/Component/Share/usePathStyles";
import DrawerComponent from "./Dashboard/Dashboard-Component/DrawerComponent";
export default function CustomerPath() {
  const classes = usePathStyles();
  const history = useHistory();
  return (
    <Box className={classes.container}>
      <DrawerComponent onReport />
      <Typography className={classes.title} variant="h2" align="center">
        Customer
      </Typography>
      <List>
        {[
          ["Big Spender", "customer/bigspender", false],
          ["Frequent Members", "customer/frequent", false],
          ["Members", "customer/member", false],
          ["Walk-In", "customer/walk-in", false],
          ["All Customers", "customer/all", false],
        ].map((text, _) => (
          <Box>
            <Button
              disabled={text[2]}
              variant={"outlined"}
              className={classes.button}
              onClick={() => {
                history.push({
                  pathname: "/bi/report/" + text[1],
                });
              }}
            >
              {text[0]}
            </Button>
          </Box>
        ))}
      </List>
    </Box>
  );
}
